export default "__VITE_ASSET__817271a1__"